module.exports = __webpack_public_path__ + "media/club_deals/current_opportunities_vertical_card1-94d5931a.webp";